import { formatNumber } from '../lib/format';
import type { FbcPerformance } from '../types';

type Props = {
  fbcs: FbcPerformance[];
  onDrillIn: (fbcName: string) => void;
};

export default function FbcCardGrid({ fbcs, onDrillIn }: Props) {
  return (
    <div className="ds-fbc-grid">
      {fbcs.map((fbc) => (
        <button
          type="button"
          key={fbc.fbcName}
          className="ds-fbc-card"
          onClick={() => onDrillIn(fbc.fbcName)}
        >
          <div className="ds-fbc-card-head">
            <div className="ds-fbc-card-name">{fbc.fbcName || 'Unknown'}</div>
            <div className="ds-fbc-card-count">{fbc.franchiseeCount} franchisees</div>
          </div>
          <div className="ds-fbc-card-stats">
            <div>
              <div className="ds-fbc-card-stat-value">{formatNumber(fbc.totalCalls)}</div>
              <div className="ds-fbc-card-stat-label">Calls</div>
            </div>
            <div>
              <div className="ds-fbc-card-stat-value">{fbc.answerRate || 0}%</div>
              <div className="ds-fbc-card-stat-label">Answer</div>
            </div>
            <div>
              <div className="ds-fbc-card-stat-value">{fbc.qualityRate || 0}%</div>
              <div className="ds-fbc-card-stat-label">Quality</div>
            </div>
            <div>
              <div className="ds-fbc-card-stat-value">{formatNumber(fbc.booked ?? 0)}</div>
              <div className="ds-fbc-card-stat-label">Booked</div>
            </div>
            <div>
              <div className="ds-fbc-card-stat-value">{fbc.bookingRate || 0}%</div>
              <div className="ds-fbc-card-stat-label">Booking</div>
            </div>
            <div>
              <div className="ds-fbc-card-stat-value">{formatNumber(fbc.assessmentsBooked ?? 0)}</div>
              <div className="ds-fbc-card-stat-label">Assessments</div>
            </div>
            <div>
              <div className="ds-fbc-card-stat-value">{formatNumber(fbc.interviewsScheduled ?? 0)}</div>
              <div className="ds-fbc-card-stat-label">Interviews</div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
